module.exports = __webpack_public_path__ + "static/media/StatisticMobile.cf83fa84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/artist-ui/components/Image/StatisticMobile.svg
// module id = 411
// module chunks = 0